import {Injectable} from '@angular/core';
import {Http} from '@angular/http';

import 'rxjs/add/operator/toPromise';

@Injectable()
export class ActionsService {
    private api_url_get_all_actions = './api/server.php?cmd=GET_ACTIONS';
    private api_url_get_details_actions = './api/server.php?cmd=GET_DETAILS_ACTIONS';

    constructor(private http: Http) {

    }

    getAllActions(code: any, user: any, date: any): Promise<Object> {
        return this.http.get(this.api_url_get_all_actions
            + '&code=' + code
            + '&user=' + user
            + '&date=' + date
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    getDetailsActions(id_action_user: any): Promise<Object> {
        return this.http.get(this.api_url_get_details_actions
            + '&id_action_user=' + id_action_user
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }

}



// WEBPACK FOOTER //
// ./src/app/actions.service.ts